import { api } from '../axios'
import type { ApiResponse } from '../../../types'

export const priorityBadgeTypesApi = {
  getAll: () =>
    api.get<ApiResponse<any[]>>('/priority-badge-types'),

  getActive: () =>
    api.get<ApiResponse<any[]>>('/priority-badge-types/active'),

  getById: (id: number) =>
    api.get<ApiResponse<any>>(`/priority-badge-types/${id}`),

  create: (data: { name: string, is_active?: boolean }) =>
    api.post<ApiResponse<any>>('/priority-badge-types', data),

  update: (id: number, data: { name: string, is_active?: boolean }) =>
    api.put<ApiResponse<any>>(`/priority-badge-types/${id}`, data),

  delete: (id: number) =>
    api.delete<ApiResponse>(`/priority-badge-types/${id}`),

  hardDelete: (id: number) =>
    api.delete<ApiResponse>(`/priority-badge-types/${id}/permanent`),
}

